<div class="content">
  <div class="layout-wrapper">
    <div class="page-header">
      <app-global-header
        [trackingScreenName]="trackingScreenName"
        [trackingObject]="trackingObject"
        [route]="headerCtaRoute"
        [label]="headerCtaLabel"
      >
      </app-global-header>
    </div>

    <div class="page-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
